export const BASE_URL: string = "/writer/web";

export const NLP_PATH = "/nlu";
export const NLP_EDIT_TOPIC_PATH = "/nlu/edit-topic";
export const NLP_SEARCH_TOPIC_PATH = "/nlu/search";